import { render } from "./ModalMessage.vue?vue&type=template&id=f3bdd59a&scoped=true"
import script from "./ModalMessage.vue?vue&type=script&lang=js"
export * from "./ModalMessage.vue?vue&type=script&lang=js"

import "./ModalMessage.vue?vue&type=style&index=0&id=f3bdd59a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3bdd59a"]])

export default __exports__